module.exports = __webpack_public_path__ + "img/Icon-twitter.38f779af.svg";